var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-of",class:_vm.cardclass,style:(`minHeight: ${_vm.minheight} !important`)},[_c('header',{staticClass:"white--text text-h6 text-center rounded-of-top",class:_vm.headerclass},[_vm._t("header")],2),_c('main',[_vm._t("default")],2),_c('footer',{staticClass:"rounded-of-bottom",class:_vm.footerclass},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }